module.exports = __webpack_public_path__ + "static/img/H6BAN3.11dc2c75.jpg";